import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import PriceListService from "services/PriceListService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllPriceList = createAsyncThunk(
  "price-list/getAllPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PriceListService.getAllPriceList();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createPriceList = createAsyncThunk(
  "price-list/createPriceList",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.createPriceList(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updatePriceList = createAsyncThunk(
  "price-list/updatePriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.updatePriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const changeStatusPriceList = createAsyncThunk(
  "price-list/changeStatusPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.changeStatusPriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deletePriceList = createAsyncThunk(
  "price-list/deletePriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.deletePriceList(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getStoreListPriceList = createAsyncThunk(
  "price-list/getStoreListPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PriceListService.getStoreListPriceList();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getStorePriceList = createAsyncThunk(
  "price-list/getStorePriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { storeId } = data;
      const response =
        await PriceListService.getStorePriceList(storeId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const applyStoresPriceList = createAsyncThunk(
  "price-list/applyStoresPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.applyStoresPriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const applyStorePriceList = createAsyncThunk(
  "price-list/applyStorePriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.applyStorePriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getProductsByPriceList = createAsyncThunk(
  "price-list/getProductsByPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PriceListService.getProductsByPriceList(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getProductDetailPriceList = createAsyncThunk(
  "price-list/getProductDetailPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PriceListService.getProductDetailPriceList(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateItemsPriceList = createAsyncThunk(
  "price-list/updateItemsPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.updateItemsPriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const resetItemsPriceList = createAsyncThunk(
  "price-list/resetItemsPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.resetItemsPriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const bulkDiscountPriceList = createAsyncThunk(
  "price-list/bulkDiscountPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.bulkDiscountPriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const bulkStatusPriceList = createAsyncThunk(
  "price-list/bulkStatusPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PriceListService.bulkStatusPriceList(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getHistoryPriceList = createAsyncThunk(
  "price-list/getHistoryPriceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PriceListService.getHistoryPriceList(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  priceLists: [],
  products: [],
  totalCount: 0,
  stores: [], 
  storePrice: {},
  productDetail: {},
};
export const PriceListSlice = createSlice({
  name: "price-list",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.priceLists = action.payload;
      })
      .addCase(getAllPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updatePriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(changeStatusPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeStatusPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deletePriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getStoreListPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStoreListPriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.stores = action.payload;
      })
      .addCase(getStoreListPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getStorePriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStorePriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.storePrice = action.payload;
      })
      .addCase(getStorePriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(applyStoresPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(applyStoresPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(applyStoresPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(applyStorePriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(applyStorePriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(applyStorePriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getProductsByPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductsByPriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload?.data;
        state.totalCount = action.payload?.totalCount;
      })
      .addCase(getProductsByPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getProductDetailPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductDetailPriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.productDetail = action.payload;
      })
      .addCase(getProductDetailPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateItemsPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateItemsPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateItemsPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(resetItemsPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetItemsPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resetItemsPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(bulkDiscountPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(bulkDiscountPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(bulkDiscountPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(bulkStatusPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(bulkStatusPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(bulkStatusPriceList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getHistoryPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHistoryPriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getHistoryPriceList.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = PriceListSlice.actions;

export default PriceListSlice.reducer;
